import ExistClientMapper from '@/modules/common/hiring/mappers/MID/ExistClientMapper'
import GetRecoveryMapper from './MID/GetRecoveryMapper'
import SaveDocumentMapper from './MID/SaveDocumentMapper'
import SavePolicyHolderMapper from './MID/SavePolicyHolderMapper'
import SaveQuotationMapper from '@/modules/common/common/mappers/MID/SaveQuotationMapper'
import AdditionalCoveragesConfig from '@/modules/foreign-health/hiring/mappers/DXP/AdditionalCoveragesConfig'

export default {
  GetRecoveryMapper,
  SaveDocumentMapper,
  ExistClientMapper,
  SavePolicyHolderMapper,
  SaveQuotationMapper,
  AdditionalCoveragesConfig
}
